import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-box-footer',
  templateUrl: './info-box-footer.component.html',
  styleUrls: ['./info-box-footer.component.css']
})
export class InfoBoxFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
